import React, { useState, useEffect } from "react";
import { updateItem, getData } from "../Tools/helpers";
import Alert from "@mui/material/Alert";
import { PageTitle } from "../components/PageHeader";

import TableHistoryCustom from "../components/TableHistoryCustom";
import DialogCustom from "../components/DialogCustom";

const HistoryPayments = () => {
  const [userData] = useState(JSON.parse(localStorage.getItem("USER_IUMV")));
  const [data, setData] = useState([]);
  const [itemApproved, setItemApproved] = useState(0);
  const [isDialog, setIsDialog] = useState(false);
  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const FieldsCustomTable = [
    { name: "code", label: "Código" },
    { name: "name_student", label: "Nombre" },
    { name: "campus", label: "Campus" },
    { name: "description", label: "Concepto" },
    { name: "month", label: "Mes" },
    { name: "transfer_date", label: "Fecha" },
    { name: "total", label: "Total" },
    { name: "method_payment", label: "Forma de pago" },
    { name: "status_description", label: "Estatus" },
    { name: "approved_by", label: "Apropado por" },
    { name: "approved_date", label: "Fecha aprobación" },
    { name: "status", label: "" },
  ];

  const getPayments = async () => {
    const route = "PaymentFourMonth";
    const send = await getData(route);
    if (send.code === 200) {
      setData(send.data);
    }
  };

  const approvedPayment = async (option) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    setIsDialog(false);
    if (!option) {
      return;
    }
    setMessage({
      status: true,
      message: "Cancelando...",
      label: "info",
    });

    const dataStatus = {
      status: 0,
      status_description: "Aprobado",
    };

    const route = "ApprovePaymentFourMonth";
    const send = await updateItem(`${route}/${itemApproved.id}`, dataStatus);
    if (send.code === 200) {
      setMessage({
        status: true,
        message: "Se ha aprobado correctamente",
        label: "success",
      });
      getPayments();
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  };

  const downloadEvidence = (item) => {
    const evidence = data.filter(evidence=> parseInt(evidence.code) === parseInt(item.code))[0];
    var a = document.createElement("a");
    a.href = evidence.evidence;
    a.download = `${evidence.code}_${evidence.name_student}_${evidence.month}`;
    a.click();
  };

  const activeDialog = (row) => {
    setItemApproved(row);
    setIsDialog(true);
  };

  useEffect(() => {
    getPayments();
  }, []);

  return (
    <div className="flex-1">
      <DialogCustom
        open={isDialog}
        message={{ title: "Aprobar", message: "¿Desea aprobar el pago?" }}
        action={approvedPayment}
      />
      <div className="flex-1 mb-10">
        <PageTitle>Historial de últimos pagos</PageTitle>
        {message.status ? (
          <Alert className="mt-2" severity={message.label}>
            {message.message}
          </Alert>
        ) : (
          ""
        )}
        <TableHistoryCustom
          fields={FieldsCustomTable}
          data={data}
          actionType={["downloadEvidence"]}
          action={activeDialog}
          action2={downloadEvidence}
        />
      </div>
    </div>
  );
};

export default HistoryPayments;
